import React from "react";
import propic from "../assets/images/carousel-1.jpg";
import OptimizedImage from "../components/OptimizedImage";

// Components
import Header from "../components/Header";
import Footer from "../components/Footer";
import BreadCrumb from "../components/Breadcrumb";
import NewsLetter from "../components/NewsLetter";

// UI
import { Instagram, WhatsApp, YouTube } from "@mui/icons-material";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailIcon from "@mui/icons-material/Email";
import SEO from "../components/SEO";

const SOCIALS = [
  {
    href: "https://wa.me/+393462721890",
    icon: <WhatsApp className="large-icon" />,
    key: "wa",
  },
  {
    href: "https://www.instagram.com/ilariastumpo_yogaecoaching/",
    icon: <Instagram className="large-icon" />,
    key: "ig",
  },
  {
    href: "https://www.youtube.com/@ilariastumpo",
    icon: <YouTube className="large-icon" />,
    key: "yt",
  },
];

const CONTACTS = [
  {
    href: "tel:+393463721890",
    icon: <LocalPhoneIcon />,
    label: "+39 346 3721890",
    key: "phone",
  },
  {
    href: "mailto:ilariastumpo.coaching@gmail.com",
    icon: <EmailIcon />,
    label: "ilariastumpo.coaching@gmail.com",
    key: "mail",
  },
];

function About() {
  return (
    <>
      <SEO title="Chi sono" />
      <Header />
      <section id="about">
        <div className="content-container">
          <BreadCrumb />
          <div className="profile-card">
            <div className="profile-header">
              <OptimizedImage
                src={propic}
                alt="Ritratto di Ilaria Stumpo, insegnante di yoga e coach del benessere"
                width={300}
                height={300}
                className="profile-image"
                loading="eager"
                style={{
                  borderRadius: "50%",
                  aspectRatio: "1/1",
                }}
              />
              <h2 className="profile-name">Ilaria Stumpo</h2>
              <p className="profile-title">
                Insegnante di Yoga e Coach del Benessere
              </p>
            </div>

            <div className="social-links">
              {SOCIALS.map(({ href, icon, key }) => (
                <a
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  key={key}
                  className="social-icon"
                  aria-label={`Visit my ${key}`}
                >
                  {React.cloneElement(icon, { sx: { fontSize: 28 } })}
                </a>
              ))}
            </div>

            <div className="divider" />

            <div className="contact-info">
              {CONTACTS.map(({ href, icon, label, key }) => (
                <a href={href} key={key} className="contact-item">
                  <span className="contact-icon">{icon}</span>
                  <span className="contact-text">{label}</span>
                </a>
              ))}
            </div>
          </div>
          <p className="paragraph">
            Mi chiamo Ilaria Stumpo e sono un’appassionata insegnante di yoga e
            coach del benessere, costantemente impegnata in un processo di
            continua crescita personale e professionale.
            <br />
            <br />
            Il mio primo incontro con lo yoga è avvenuto molti anni fa, durante
            un periodo per nulla sereno della mia adolescenza. È stato il primo
            seme piantato che è rimasto lì per un po’ in attesa di essere
            germogliato.
            <br />
            Nel 2020 mi è stata diagnosticata la fibromialgia, una malattia
            cronica dell’apparato muscoloscheletrico. È stato allora che la mia
            intuizione mi ha portato ad iniziare a praticare yoga ogni giorno e
            da lì non ho mai smesso. Lo yoga mi ha permesso di ridare fiducia ad
            un corpo fragile e dolorante, ma non solo: mi ha permesso di
            intraprendere un percorso di conoscenza e di scoperta di me stessa e
            della mia interiorità. Ad un certo punto mi sono accorta che la
            pratica non bastava più e che avevo bisogno di andare più a fondo...
            Mi sono iscritta al mio primo di corso di formazione in Hatha Yoga:
            un primo passo che mi ha permesso di entrare a contatto con una
            forma di yoga che amo particolarmente e che continuo a studiare
            costantemente.
            <br />
            Successivamente ho esplorato nuove strade, ottenendo il diploma di
            insegnante di Vinyasa Yoga, uno stile dinamico che ho riadattato
            nelle mie lezioni con particolare attenzione all’osservazione e alla
            consapevolezza del sè.
            <br />
            In seguito, ho iniziato ad approfondire l’universo femminile e mi
            sono specializzata sulla maternità, ottenendo il diploma di
            insegnante di yoga in gravidanza e nel post-parto con metodo yoga in
            fascia.
            <br />
            Dopo essere diventata mamma, mi sono resa conto ancora di più di
            quanto lo yoga possa essere anche uno strumento educativo per i
            piccolini, così ho deciso di completare il percorso di yoga bimbi.
            Questo mi permette di poter seguire i piccolini da quando sono nella
            pancia - prendendomi cura della loro mamma - fino alla loro
            infanzia. <br />
            Un ultimo tassello della mia attuale formazione di yoga è costituito
            dall’interesse per l’aspetto posturale, fondamentale anche per chi
            soffre di dolori cronici. Ho imparato come l’abilità di percepire la
            propria posturalità sia la chiave per vivere in armonia, anche con
            il mondo esterno, in quanto l’aspetto posturale è strettamente
            connesso alla personalità.
            <br />
            <br />
            Considero lo yoga uno strumento per raggiungere il proprio benessere
            olistico: credo che per sentirsi bene e in salute sia necessario
            armonizzare diversi aspetti interconnessi: il fisico, il mentale,
            l’emotivo… Praticare yoga permette attraverso il corpo di entrare a
            contatto con le sfere della propria interiorità per potersi
            relazionare meglio anche con il mondo esterno. Yoga è una forma di
            meditazione e ho avuto modo di approfondire ulteriori modalità,
            quali Mindfulness e Vipassana.
            <br />
            Nel 2023 ho scelto di intraprendere un percorso professionale di
            Coaching del Benessere che chiude il cerchio rispetto ai diversi
            temi legati alla salute olistica a cui mi sto dedicando da anni.
            <br />
            Il coaching del benessere è un percorso di presa di potere sulla
            propria vita per riappropriarsi della propria salute.
            <br />
            <br />
            L’intento di questo spazio è fornirvi spunti e strumenti che sono
            stati utili nella mia ricerca del Benessere, affinché ciascuno di
            voi possa sbocciare e far fiorire il proprio potenziale per vivere
            una vita consapevole e appagante.
          </p>
        </div>
      </section>
      <NewsLetter />
      <Footer />
    </>
  );
}

export default About;
